export default function Contact() {
  return (
    <section id="contact" className="relative py-24 px-12 bg-zinc-900">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex items-start justify-between mb-20">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/dbcea1a0-86b0-419a-b784-7a681353a655.png" 
              alt="Axi AS Logo" 
              className="w-10 h-10 object-contain"
            />
            <span className="text-xl font-light tracking-widest text-white">Axi AS</span>
          </div>
          <p className="text-base text-gray-400 font-light">Professional iOS Development Solutions</p>
        </div>

        {/* Contact Information */}
        <div className="grid grid-cols-2 gap-16 mb-20">
          {/* Left Column - Location */}
          <div className="space-y-6">
            <div>
              <div className="flex items-center gap-3 mb-2">
                <i className="ri-map-pin-line text-gray-500 text-base w-4 h-4 flex items-center justify-center"></i>
                <span className="text-sm text-gray-500 font-light">Address</span>
              </div>
              <p className="text-base text-white ml-7">Stallbakken 9</p>
            </div>

            <div>
              <div className="flex items-center gap-3 mb-2">
                <i className="ri-building-line text-gray-500 text-base w-4 h-4 flex items-center justify-center"></i>
                <span className="text-sm text-gray-500 font-light">City</span>
              </div>
              <p className="text-base text-white ml-7">Raelingen</p>
            </div>

            <div>
              <div className="flex items-center gap-3 mb-2">
                <i className="ri-mail-line text-gray-500 text-base w-4 h-4 flex items-center justify-center"></i>
                <span className="text-sm text-gray-500 font-light">Zip Code</span>
              </div>
              <p className="text-base text-white ml-7">2005</p>
            </div>

            <div>
              <div className="flex items-center gap-3 mb-2">
                <i className="ri-global-line text-gray-500 text-base w-4 h-4 flex items-center justify-center"></i>
                <span className="text-sm text-gray-500 font-light">Country</span>
              </div>
              <p className="text-base text-white ml-7">Norway</p>
            </div>
          </div>

          {/* Right Column - Communication */}
          <div className="space-y-6">
            <div>
              <div className="flex items-center gap-3 mb-2">
                <i className="ri-mail-send-line text-gray-500 text-base w-4 h-4 flex items-center justify-center"></i>
                <span className="text-sm text-gray-500 font-light">Email</span>
              </div>
              <a href="mailto:help@axiaas.com" className="text-base text-white ml-7 hover:text-teal-400 transition-colors cursor-pointer">
                help@axiaas.com
              </a>
            </div>

            <div>
              <div className="flex items-center gap-3 mb-2">
                <i className="ri-phone-line text-gray-500 text-base w-4 h-4 flex items-center justify-center"></i>
                <span className="text-sm text-gray-500 font-light">Phone</span>
              </div>
              <a href="tel:+13365510649" className="text-base text-white ml-7 hover:text-teal-400 transition-colors cursor-pointer">
                +1 3365510649
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-12 border-t border-gray-800">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xl font-serif text-white mb-1">© Axi AS 2025</p>
              <p className="text-sm text-gray-500">All rights reserved</p>
            </div>
            
            <div className="text-right">
              <p className="text-3xl font-serif text-gray-400 leading-relaxed">
                Innovation meets quality<br />
                in every application
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}